// extracted by mini-css-extract-plugin
export default {"container":"SingleAssetTerminal_container__85XiB"};